import { InjectionToken } from "@angular/core";
import { Resolve } from "@angular/router";
import { ILauncher } from "../../../../models/application/i-launcher";
import { IPage } from "@zaeper/communication-lib";

export const launcherPageResolverInjectionToken: InjectionToken<Resolve<IPage<ILauncher>>> = new InjectionToken<Resolve<IPage<ILauncher>>>("digital-signage-developer-dashboard.LauncherPageResolver");
